import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios'
import envUrls from '../../utils/config'
import { useParams } from "react-router-dom"
import { Typography, DialogTitle, DialogContentText, DialogContent, Tooltip, Dialog, FormLabel, FormControlLabel, RadioGroup, Radio, Box, TextField, TextareaAutosize, CardContent, CardActions, Card, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core'
import Comments from './comments/comments';
import FileBase from 'react-file-base64';
import '../../components/dialog/DialogBox.css';
import Mainnavbar from '../../components/mainNavbar/Mainnavbar';
import './Issue.css';
import { toast } from 'react-toastify';
import Navbar from '../issueTable/navbar';
import './issueTable.module.css'
import classe from './issueTable.module.css'
import Commented from './comments/commented';
// import useTime from '../../hooks/usetime';
import UseTime from '../../hooks/useTime';
import Preview from '../previewPage/preview';
import { isWindPioneersProject } from '../../hooks/useProjects';
// import InputLabel from '@mui/material/InputLabel';
// or
// import { InputLabel } from '@mui/material';




const useStyles = makeStyles({
    root: {
        minWidth: 275,
        margin: 30

    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

const Issue = () => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [project, setProject] = useState('');
    const [priority, setPriority] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('');
    const [editattachment, setEditAttachment] = useState([]);
    const [instance, setinstance] = useState('')
    const [version, setVersion] = useState('')
    const [subTool, setSubTool] = useState('')
    const [projectUrl, setProjectUrl] = useState('')
    const [report, setreport] = useState('')
    const [level, setlevel] = useState('')
    const [issueType, setissuetype] = useState('')
    const [reportedon, setreportedon] = useState('')
    const [showpreviewmodal, setshowpreviewmodal] = useState(false)
    const [leveldisable, setleveldisable] = useState(false)
    const [closingComment, setClosingComment] = useState('')
    const [pendingStage, setPendingStage] = useState(null)
    const pendingStageRef = useRef(null)
    const [commentRefreshKey, setCommentRefreshKey] = useState(0)
    const [stageApiLoading, setStageApiLoading] = useState(false)
    // const [previewmodal, setpreviewmodal] = useState(true)

    const classes = useStyles();
    const [issue, setIssue] = useState({})
    const [attachment, setAttachment] = useState(false)
    const [attachmentdata, setAttachmentdata] = useState([])
    const { id } = useParams()
    const [issueStatus, setIssueStatus] = useState('');
    const [performActionStatus, setPerformActionStatus] = useState('');
    const [receiveAttachment, setReceiveAttachment] = useState([]);
    const [receiveAttachmentLinks, setReceiveAttachmentLinks] = useState([]);
    const [attachmentToDownload, setAttachmentToDownload] = useState('in_progress');
    // axios defaults
    axios.defaults.withCredentials = true
    toast.configure();
    let param = useParams()

    localStorage.setItem('latestid', param.id)
    const notifyValidationsError = (msg) => toast.error(msg, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
    });

    const notifyValidationsSuccess = (msg) => toast(msg, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
    });
    console.log(receiveAttachment)
    function getCookie(name) {
        var found = document.cookie.split(';').filter(c => c.trim().split("=")[0] === name);
        return found.length > 0 ? found[0].split("=")[1] : null;
    }

    const showEachIssue = () => {

        console.log("called")
        setStageApiLoading(true);
        return axios.get(envUrls.baseUrl + `show_issue?issue_id=${id}&email=${getCookie('email_windbug')}`).then((response) => {


            console.log(response.data, "%c issue hai yeh", 'color:blue')
            setProject(response.data.project_name);
            setTitle(response.data.issue_title);
            setinstance(response.data.instance)
            // The backend sends the text "NULL" or "N/A" when a field is empty
            setVersion(['NULL', 'N/A'].includes(response.data.version) ? '' : response.data.version)
            setSubTool(['NULL', 'N/A'].includes(response.data.sub_tool) ? '' : response.data.sub_tool)
            setreport(response.data.username)
            setissuetype(response.data.issue_type)
            setDescription(response.data.description)
            setPriority(response.data.priority);
            setreportedon(response.data.system_date)
            localStorage.removeItem(`issue_action_stage_${id}`);
            const effectiveStage =
                response.data.issue_status === 'Reopen' &&
                response.data.issue_stage === 'Stage 7 (Closed)'
                    ? 'Stage 1'
                    : response.data.issue_stage;

            setlevel(effectiveStage)
            setAge(effectiveStage)
            setProjectUrl(response.data.project_url)

            // setEditAttachment(response.data.attachment);
            if (response.data.file_names.length > 0 && response.data.file_names[0] !== '') {
                setReceiveAttachment(response.data.file_names)
                setReceiveAttachmentLinks(response.data.attachment)
                // console.log(response.data.file_names[0].split("', '"));
            }
            const date = response.data.system_date
            const timestamp = new Date(+date).toDateString()
            if (effectiveStage === 'Stage 7 (Closed)') {
                setIssueStatus('Closed');
                setPerformActionStatus('Reopen');
            } else if (effectiveStage) {
                setIssueStatus(response.data.issue_status === 'Reopen' ? 'Reopen' : 'Open');
                setPerformActionStatus('Close');
            } else if (response.data.issue_status === 'Closed' || response.data.issue_status === 'Close') {
                setIssueStatus('Closed');
                setPerformActionStatus('Reopen');
            } else if (response.data.issue_status === 'Reopen') {
                setIssueStatus('Reopen');
                setPerformActionStatus('Close');
            } else {
                setIssueStatus('Open');
                setPerformActionStatus('Close');
            }
            // console.log(timestamp)
            const newData = {
                ...response.data,
                timestamp
            }
            if (newData.attachment !== "NULL") {
                setAttachment(() => !attachment)
            }
            setIssue(newData)
        }).catch((err) => {
            console.log(err.message)
            if (err.response?.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                window.location.href = '/login'
                notifyValidationsSuccess('Session expired, Please login again');
                sessionStorage.setItem('session_expired', 'true')

            }
        }).finally(() => {
            setStageApiLoading(false);
        })
    }

    useEffect(() => {
        showEachIssue()
    }, [])
    console.log(receiveAttachmentLinks, 'receiveAttachmentLinks')
    const changeStatus = () => {
        const fd = new FormData()
        fd.set("issue_id", id)
        fd.set("email_windbug", getCookie('email_windbug'))
        fd.set('issue_status', performActionStatus)
        axios.post(envUrls.baseUrl + `update_issue`, fd).then((response) => {

            console.log(response)
            if (response.data.message === 'Updation successfull') {
                setOpen(false);
                showEachIssue();
                if (performActionStatus === 'Close') {
                    notifyValidationsSuccess('Case has been successfully ' + performActionStatus.toLowerCase() + 'd');
                }
                else {
                    notifyValidationsSuccess('Case has been successfully ' + performActionStatus.toLowerCase() + 'ed');
                }
            }
        }).catch((err) => {
            console.log(err.message)
            if (err.response.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                window.location.href = '/login'
                notifyValidationsSuccess('Session expired, Please login again');
                sessionStorage.setItem('session_expired', 'true')

            }
        })
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (e) => {
        setOpen(false);
    };

    const handleChangeForIssue = (event) => {
        setTitle(event.target.value);
    };
    const handleChangeForProject = (event) => {
        setProject(event.target.value)
    }
    const handleChangeForPriority = (event) => {
        setPriority(event.target.value);
    };
    const handeleChangeForDesc = (event) => {
        setDescription(event.target.value);
    };

    const handleChangeForStatus = (event) => {
        setStatus(event.target.value)

    }

    const handleFile = (event) => {
        const file = event.target.files;
        var fileLength = 0
        var receivedFileLength = 0
        if (editattachment && editattachment.length > 0) {
            fileLength = editattachment.length;
        }

        if (receiveAttachment && receiveAttachment.length > 0) {
            fileLength = receiveAttachment.length;
        }

        if (file.length > 0) {
            if (file.length + fileLength + receivedFileLength <= 4) {
                console.log("yes");
                console.log(file.length)
                if (file.length === 1) {
                    for (var i = 0; i <= file.length; i++) {
                        console.log(file[i].name)
                        setEditAttachment([...editattachment, file[i]]);
                    }
                }
                else if (file.length > 1) {
                    Array.from(file).forEach((element) => {
                        console.log("element", element);
                        editattachment.push(element);
                    });
                    setEditAttachment([...editattachment]);
                }
            }
            else {
                notifyValidationsSuccess('Maximum 4 files can be uploaded')
            }
        }

    }
    // var monthsArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    // let timestamp = reportedon
    // timestamp = timestamp.slice(0, -3)

    // const date = new Date(timestamp * 1000)
    // const month = monthsArr[date.getMonth()]
    // const day = date.getDate()
    // const year = date.getFullYear()
    // const time = date.toLocaleTimeString()

    // const dateFormat = `${month} ${day}, ${year}, ${time}`
    let dateFormat = UseTime(reportedon)

    const handleEditIssue = (e) => {
        e.preventDefault()
        console.log(title, description, priority, id, status, project)
        // console.log(editattachment)
        const fd = new FormData()
        fd.set("issue_id", id)
        fd.set("timestamp", Date.now())
        fd.set("issue_title", title)
        fd.set('status', status)
        fd.set('priority', priority)
        fd.set('project_name', project)
        fd.set('description', description)
        fd.set('email', getCookie('email_windbug'))
        fd.set('issue_status', issueStatus)
        // fd.set('attachment', editattachment)
        if (editattachment === null) {
            console.log("none")
            fd.set('attachment', [])
        }
        else if (editattachment.length > 0 || editattachment !== null) {
            for (var i = 0; i < editattachment.length; i++) {
                console.log("present", editattachment[i])
                fd.append('attachment', editattachment[i])
            }
        }
        else {
            console.log("none")
            fd.set('attachment', [])
        }
        axios.post(envUrls.baseUrl + `update_issue`, fd).then((response) => {

            console.log(response)

            if (response.data.message === 'Updation successfull') {
                setOpen(false);
                showEachIssue();
                window.location.reload()
            }

        }).catch((err) => {
            console.log(err.message)
            if (err.response.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                window.location.href = '/login'
                notifyValidationsSuccess('Session expired, Please login again');
                sessionStorage.setItem('session_expired', 'true')

            }

        })
    }

    const previewAttachment = () => {
        console.log("attachmentToDownload", receiveAttachmentLinks[attachmentToDownload])
        var fileTypeSplit = receiveAttachment[attachmentToDownload].split('.');
        var length = fileTypeSplit.length;
        var fileType = fileTypeSplit[length - 1];
        var allowedFileTypes = ['jpg', 'png', 'jpeg', 'JPG', 'JPEG', 'PNG'];
        if (allowedFileTypes.includes(fileType)) {
            axios.get(envUrls.baseUrl + 'download_attachment?attachment=' + receiveAttachmentLinks[attachmentToDownload]).then((res) => {
                console.log(res);
                localStorage.setItem("downloadURL", res.data.donwload_url);
                // window.location.href = '/preview';
                // window.open(res.data.donwload_url)
                setshowpreviewmodal(true)
            }).catch((err) => {
                console.log(err)
                if (err.response.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                    window.location.href = '/login'
                    notifyValidationsSuccess('Session expired, Please login again');
                    sessionStorage.setItem('session_expired', 'true')

                }
            })
        }
        else {
            notifyValidationsSuccess("Only image files can be previewed");
        }
        // console.log(fileName)

    }

    const downloadAttachment = () => {
        console.log("attachmentToDownload", attachmentToDownload == 'in_progress')
        if (attachmentToDownload !== 'in_progress') {

            axios.get(envUrls.baseUrl + 'download_attachment?attachment=' + encodeURIComponent(receiveAttachmentLinks[attachmentToDownload == 'in_progress' ? '' : attachmentToDownload])).then((res) => {
                if (res.status == 401) {
                    window.location.href = '/login'
                    // useHistory()
                }
                console.log(res);
                window.open(res.data.donwload_url, 'Download')
            }).catch((err) => {
                console.log(err)
                if (err.response.status == 401 && sessionStorage.getItem('logging_out') !== 'true') {
                    window.location.href = '/login'
                    notifyValidationsSuccess('Session expired, Please login again');
                    sessionStorage.setItem('session_expired', true)
                }
            })
        }

    }

    // const openFileInput = () => {
    //     document.getElementById('fileupload').click();
    // }

    console.log(issue)



    const [age, setAge] = React.useState('');

    const updateIssueStageApi = (newStage) => {
        const fd = new FormData();
        fd.set('issue_id', id);
        fd.set('issue_stage', newStage);
        return axios.post(envUrls.baseUrl + 'update_issue', fd);
    };

    const syncActionButtonWithStage = (stageValue) => {
        if (stageValue === 'Stage 7 (Closed)') {
            setIssueStatus('Closed');
            setPerformActionStatus('Reopen');
        } else {
            setIssueStatus('Open');
            setPerformActionStatus('Close');
        }
    };

    const isUnauthorizedStageMessage = (msg) =>
        typeof msg === 'string' &&
        (msg.toLowerCase().includes('only authorised') ||
            msg.toLowerCase().includes('only authorized') ||
            msg.toLowerCase().includes('not authorised') ||
            msg.toLowerCase().includes('not authorized'));

    const handleStageUpdateResponse = (res, newStage) => {
        if (res.data?.message) {
            toast(res.data.message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 5000,
            });
        }
        if (isUnauthorizedStageMessage(res.data?.message)) {
            setleveldisable(true);
            setAge(level);
            return Promise.resolve(false);
        }
        setlevel(newStage);
        setAge(newStage);
        syncActionButtonWithStage(newStage);
        return showEachIssue().then(() => true);
    };

    const applyPendingStageAfterComment = () => {
        const stageToApply = pendingStageRef.current;
        if (!stageToApply) {
            return Promise.resolve();
        }
        pendingStageRef.current = null;
        setPendingStage(null);
        setStageApiLoading(true);
        return updateIssueStageApi(stageToApply)
            .then((res) => handleStageUpdateResponse(res, stageToApply))
            .catch((err) => {
                const errMsg = err.response?.data?.message;
                if (errMsg) {
                    toast(errMsg, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 5000,
                    });
                }
                if (err.response?.status === 403 || isUnauthorizedStageMessage(errMsg)) {
                    setleveldisable(true);
                    setAge(level);
                }
            })
            .then(() => {
                setCommentRefreshKey((k) => k + 1);
                return true;
            })
            .finally(() => {
                setStageApiLoading(false);
            });
    };

    useEffect(() => {
        pendingStageRef.current = pendingStage;
    }, [pendingStage]);

    const handleChange = (event) => {
        const newStage = event.target.value;
        if (!newStage || newStage === age) {
            return;
        }
        setStageApiLoading(true);
        updateIssueStageApi(level || age)
            .then((res) => {
                if (isUnauthorizedStageMessage(res.data?.message)) {
                    toast(res.data.message, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 3000,
                    });
                    setleveldisable(true);
                    setAge(level);
                    return;
                }
                pendingStageRef.current = newStage;
                setPendingStage(newStage);
                if (newStage === 'Stage 7 (Closed)') {
                    setPerformActionStatus('Close');
                    if (!closingComment.trim()) {
                        notifyValidationsError(
                            'Please add a comment in the Closing/Re-opening Comment box and click Close ' +
                                (issueType || 'Bug') +
                                '.'
                        );
                    } else {
                        notifyValidationsError(
                            'Please click Close ' +
                                (issueType || 'Bug') +
                                ' to submit your comment and apply this stage.'
                        );
                    }
                    return;
                }
                if (!closingComment.trim()) {
                    notifyValidationsError(
                        'Please add a comment in the Closing/Re-opening Comment box and click Submit to apply this stage.'
                    );
                } else {
                    notifyValidationsError(
                        'Please click Submit to submit your comment and apply this stage.'
                    );
                }
            })
            .catch((err) => {
                if (
                    err.response?.status === 401 &&
                    sessionStorage.getItem('logging_out') !== 'true'
                ) {
                    window.location.href = '/login';
                    notifyValidationsSuccess('Session expired, Please login again');
                    sessionStorage.setItem('session_expired', 'true');
                    return;
                }
                const errMsg =
                    err.response?.data?.message ||
                    'Only authorised person can change the stage of a bug/request.';
                toast(errMsg, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 3000,
                });
                if (err.response?.status === 403 || isUnauthorizedStageMessage(errMsg)) {
                    setleveldisable(true);
                    setAge(level);
                }
            })
            .finally(() => {
                setStageApiLoading(false);
            });
    };
    return (
        <div className={classe.box}>
            <Navbar></Navbar>
            <div className={classe.box2}>
                <div className={classe.issuebox}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>

                            <p style={{ fontSize: '1.4rem', marginLeft: '1.4rem' }} >{issueType}</p>
                        </div>
                        <div >
                            <Box sx={{ minWidth: 120 }} >

                                <FormControl sx={{ m: 1, minWidth: 120 }}>

                                    <Select
                                        value={age}
                                        onChange={handleChange}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        style={{ minWidth: '200px', textAlign: 'center' }}
                                        disabled={leveldisable}
                                    >
                                        <MenuItem disabled={leveldisable} value="">
                                            <label>Assign the Case Level</label>
                                        </MenuItem>

                                        <MenuItem value={'Stage 1'}>Stage 1 - Bug/Request</MenuItem>
                                        <MenuItem value={'Stage 2'}>Stage 2 - Reproducing</MenuItem>
                                        <MenuItem value={'Stage 3'}>Stage 3 - Implementing Fix/Request</MenuItem>
                                        <MenuItem value={'Stage 4'}>Stage 4 - Internal Testing</MenuItem>
                                        <MenuItem value={'Stage 5'}>Stage 5 - Dev UAT</MenuItem>
                                        <MenuItem value={'Stage 6'}>Stage 6 - Fixed in Beta</MenuItem>
                                        <MenuItem value={'Stage 7 (Closed)'}>Stage 7 - Closed</MenuItem>

                                    </Select>

                                </FormControl>

                            </Box>
                        </div>

                    </div>
                    {/* start boxes for input */}
                    <Card elevation={3} className={classe.inputbox}>

                        {/* ── Row 1: Case ID  +  Version (Bug) / Sub-tool (Request) / Case Instance (others) ── */}
                        <div className={classe.inputbox1}>
                            <div>
                                <label htmlFor="inputFirstName" className="form-label">Case ID:</label>
                                <br />
                                <div className='input-lineBy field-box'>{id}</div>
                            </div>

                            {isWindPioneersProject(project) ? (
                                /* Windscribe Bug → Version next to Case ID; Windscribe Request → Sub-tool; Windwizz → nothing */
                                (project || '').toLowerCase() !== 'windwizz' ? (
                                    issueType !== 'Request' ? (
                                        /* Bug: show Version in row 1 */
                                        <div>
                                            <label htmlFor="inputFirstName" className="form-label">Version:</label>
                                            <br />
                                            <div className='input-lineBy field-box'>{version || '—'}</div>
                                        </div>
                                    ) : (
                                        /* Request: show Sub-tool in row 1 */
                                        <div>
                                            <label htmlFor="inputFirstName" className="form-label">Sub-tool:</label>
                                            <br />
                                            <div className='input-lineBy field-box'>{subTool || '—'}</div>
                                        </div>
                                    )
                                ) : null /* Windwizz: nothing beside Case ID */
                            ) : (
                                <div>
                                    <label htmlFor="inputFirstName" className="form-label">Case Instance:</label>
                                    <br />
                                    <div className='input-lineBy field-box'>{instance || '—'}</div>
                                </div>
                            )}
                        </div>

                        {/* ── Rows 2 / 3: vary by project ── */}
                        {(project || '').toLowerCase() === 'windwizz' ? (
                            /* Windwizz — Row 2: Reported By + Date */
                            <div className={classe.inputbox2}>
                                <div>
                                    <label htmlFor="inputFirstName" className="form-label">Reported By:</label>
                                    <br />
                                    <div className='input-lineBy field-box'>{report}</div>
                                </div>
                                <div>
                                    <label htmlFor="inputFirstName" className="form-label">Date:</label>
                                    <br />
                                    <div className='input-lineBy field-box'>{dateFormat}</div>
                                </div>
                            </div>
                        ) : isWindPioneersProject(project) ? (
                            issueType !== 'Request' ? (
                                <>
                                    {/* Windscribe Bug — Row 2: Sub-tool + Reported By */}
                                    <div className={classe.inputbox2}>
                                        <div>
                                            <label htmlFor="inputFirstName" className="form-label">Sub-tool:</label>
                                            <br />
                                            <div className='input-lineBy field-box'>{subTool || '—'}</div>
                                        </div>
                                        <div>
                                            <label htmlFor="inputFirstName" className="form-label">Reported By:</label>
                                            <br />
                                            <div className='input-lineBy field-box'>{report}</div>
                                        </div>
                                    </div>
                                    {/* Windscribe Bug — Row 3: Date */}
                                    <div className={classe.inputbox3}>
                                        <div>
                                            <label htmlFor="inputFirstName" className="form-label">Date:</label>
                                            <br />
                                            <div className='input-lineBy field-box'>{dateFormat}</div>
                                        </div>
                                        <div style={{ visibility: 'hidden' }} aria-hidden="true">
                                            <label className="form-label">Date:</label>
                                            <br />
                                            <div className='input-lineBy field-box'></div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                /* Windscribe Request — Row 2: Reported By + Date */
                                <div className={classe.inputbox2}>
                                    <div>
                                        <label htmlFor="inputFirstName" className="form-label">Reported By:</label>
                                        <br />
                                        <div className='input-lineBy field-box'>{report}</div>
                                    </div>
                                    <div>
                                        <label htmlFor="inputFirstName" className="form-label">Date:</label>
                                        <br />
                                        <div className='input-lineBy field-box'>{dateFormat}</div>
                                    </div>
                                </div>
                            )
                        ) : (
                            <>
                                {/* Non-WindPioneers — Row 2: Case Priority + Reported By */}
                                <div className={classe.inputbox2}>
                                    <div>
                                        <label htmlFor="inputFirstName" className="form-label">Case Priority:</label>
                                        <br />
                                        <div className='input-lineBy field-box'>{priority || '—'}</div>
                                    </div>
                                    <div>
                                        <label htmlFor="inputFirstName" className="form-label">Reported By:</label>
                                        <br />
                                        <div className='input-lineBy field-box'>{report}</div>
                                    </div>
                                </div>
                                {/* Non-WindPioneers — Row 3: Date */}
                                <div className={classe.inputbox3}>
                                    <div>
                                        <label htmlFor="inputFirstName" className="form-label">Date:</label>
                                        <br />
                                        <div className='input-lineBy field-box'>{dateFormat}</div>
                                    </div>
                                    <div style={{ visibility: 'hidden' }} aria-hidden="true">
                                        <label className="form-label">Date:</label>
                                        <br />
                                        <div className='input-lineBy field-box'></div>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className={classe.descriptionbox} >
                            <label htmlFor="inputFirstName" className="form-label">Case Title:</label>
                            <br />
                            <textarea style={{ borderRadius: '5px', width: '29rem' }} rows="3" readOnly value={title} className='input-lineBy'></textarea>
                        </div>

{issue.project_url && issue.project_url !== "NULL" && (
  <div className={classe.descriptionbox}>
    <label className="form-label">Project URL:</label>
    <br />
    <a
      href={projectUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: "inline-block", width: "95%", wordBreak: "break-all" }}
    >
      {projectUrl}
    </a>
  </div>
)}

                        <div className={classe.descriptionbox} >
                            <label htmlFor="inputFirstName" className="form-label">Case Description:</label>
                            <br />
                            <textarea style={{ borderRadius: '5px', width: '29rem' }} name="" id="" cols="45" rows="8" readOnly value={description} className='input-lineBy'></textarea>
                        </div>

                        {/* this start for files uploaded */}
                        <div className={classe.file}>
                            <label htmlFor="inputFirstName" className="form-label">File(s) Uploaded:              </label>
                            <select value={attachmentToDownload} onChange={(e) => { setAttachmentToDownload(e.target.value) }}
                                class="bootstrap-select  font-weight-medium"
                                style={{ cursor: "pointer", width: "200px", height: "37px", backgroundColor: "#C4C4C4", marginLeft: "15px", borderRadius: "5px" }}

                            >
                                {receiveAttachment.length == 0 ? '' : <option value="in_progress" className="select">
                                    Select file from here
                                </option>}
                                {receiveAttachment.length > 0 ? receiveAttachment.map((val, ind) => {
                                    return (
                                        <option value={ind} className="select">
                                            {val}
                                        </option>)
                                }) : <option value="in_progress" className="select">
                                    No file attached
                                </option>}

                            </select>

                        </div>
                        <div className={classe.filebutt} >
                            <button onClick={previewAttachment}>Preview</button>
                            <button onClick={downloadAttachment}>Download</button>
                        </div>
                    </Card>
                </div>
                <div style={{ border: 'solid 1px lightgrey', height: '300px', marginTop: '230px', marginRight: '15px' }}></div>

                {/* another box  */}
                <div className={classe.commentbox}>

                    <Commented
                        id={id}
                        email={getCookie('email_windbug')}
                        performActionStatus={performActionStatus}
                        issueStatus={issueStatus}
                        issueType={issueType}
                        closingComment={closingComment}
                        setClosingComment={setClosingComment}
                        pendingStage={pendingStage}
                        selectedStage={age}
                        stageApiLoading={stageApiLoading}
                        onAfterCommentPosted={applyPendingStageAfterComment}
                        commentRefreshKey={commentRefreshKey}
                        onStageUpdated={(newStage) => {
                            pendingStageRef.current = null;
                            setPendingStage(null);
                            setlevel(newStage);
                            setAge(newStage);
                            syncActionButtonWithStage(newStage);
                        }}
                    />

                </div>
            </div>
            {showpreviewmodal && <Preview open={showpreviewmodal} close={setshowpreviewmodal} />}
        </div >

    );
}


export default Issue
